module.exports = __webpack_public_path__ + "img/paginaprodotto_1920X350.18197d82.jpg";